export default function objectToFormData(data, convertNumbers, ignoreFields) {
    if (convertNumbers === void 0) { convertNumbers = false; }
    if (ignoreFields === void 0) { ignoreFields = []; }
    var formData = new FormData();
    var _loop_1 = function (key) {
        //
        if (data.hasOwnProperty(key)) {
            // Skip undefined values or values to be ignored
            if (!(ignoreFields.indexOf(key) >= 0) && data[key] != undefined) {
                // Check if value is array
                if (Array.isArray(data[key])) {
                    data[key].forEach(function (value, index) {
                        // If contents of array is object, loop through keys
                        if (typeof value === 'object') {
                            for (var valueKey in value) {
                                if (value[valueKey] != undefined) {
                                    formData.append(key + "[".concat(index, "].").concat(valueKey), _formatValue(value[valueKey], convertNumbers));
                                }
                            }
                        }
                        else {
                            formData.append(key + "[".concat(index, "]"), _formatValue(value, convertNumbers));
                        }
                    });
                }
                else {
                    formData.append(key, _formatValue(data[key], convertNumbers));
                }
            }
        }
    };
    // Loop through keys in data object
    for (var key in data) {
        _loop_1(key);
    }
    return formData;
}
/**
 *
 * @param value
 * @returns {*}
 * @private
 */
export function _parseCurrency(value) {
    value = value + '';
    value = parseFloat(value.replace(',', '.'));
    return isNaN(value) ? 0 : value;
}
/**
 *
 * @param dataURI
 * @return {Blob}
 */
export function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    }
    else {
        byteString = unescape(dataURI.split(',')[1]);
    }
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}
/**
 *
 * @param value
 * @param convertNumbers
 * @returns {*}
 * @private
 */
export function _formatValue(value, convertNumbers) {
    if (convertNumbers === void 0) { convertNumbers = false; }
    if (value instanceof Date) {
        return _formatDate(value);
    }
    if ((typeof value === 'number') && convertNumbers) {
        return value.toString().replace('.', ',');
    }
    return value;
}
/**
 * Returns a Date object based on string with format YYYY-MM-DD
 *
 * @param s String with format YYYY-MM-DDx
 * @param reverse boolean, is the date reversed DD-MM--YYYY
 * @param includesTime boolean Also include time
 * @param offsetHalfday boolean Offset hourse by +12 if no time is set
 * @returns {Date}
 * @private
 */
export function _formatStringToDate(s, reverse, includesTime, offsetHalfday) {
    if (reverse === void 0) { reverse = false; }
    if (includesTime === void 0) { includesTime = false; }
    if (offsetHalfday === void 0) { offsetHalfday = false; }
    // Split date and time
    var dt = null;
    if (includesTime) {
        dt = s.split(' ');
        s = dt[0];
        dt = dt.length > 1 ? dt[1] : null;
    }
    // Extract date
    var a = s.split('-');
    if (reverse) {
        a.reverse();
    }
    var year = a.length > 0 ? parseInt(a[0]) : undefined;
    var month = a.length > 1 ? parseInt(a[1]) : undefined;
    var day = a.length > 2 ? parseInt(a[2]) : undefined;
    // Extract time
    var hours = offsetHalfday ? 12 : null;
    var minutes = null;
    var seconds = null;
    // Has time
    if (dt) {
        var dta = dt.split(':');
        hours = dta.length > 0 ? parseInt(dta[0]) : null;
        minutes = dta.length > 1 ? parseInt(dta[1]) : null;
        seconds = dta.length > 2 ? parseInt(dta[2]) : null;
    }
    return new Date(year, month - 1, day, hours, minutes, seconds);
}
export function _formatDate(date, reverse) {
    if (reverse === void 0) { reverse = false; }
    if (!date || (date instanceof Date && isNaN(date.getTime()))) {
        return null;
    }
    var day = _addZeros(date.getDate());
    var month = _addZeros(date.getMonth() + 1);
    var year = date.getFullYear();
    if (reverse) {
        return "".concat(year, "-").concat(month, "-").concat(day);
    }
    else {
        return "".concat(day, "-").concat(month, "-").concat(year);
    }
}
export function _addZeros(value, length) {
    if (length === void 0) { length = 2; }
    var s = value + '';
    while (s.length < length) {
        s = '0' + s;
    }
    return s;
}
/**
 * Strips http:// or https:// or anything before :// from the specified value
 *
 * @param value
 * @param reAdd, try to re-add the protocol
 * @returns {string|null}
 * @private
 */
export function stripProtocolFromUrl(value, reAdd) {
    if (reAdd === void 0) { reAdd = false; }
    if (!value) {
        return value;
    }
    var parts = value.split('://');
    var stripped = parts[parts.length - 1];
    if (reAdd) {
        if (isHTTP(value)) {
            return 'http://' + stripped;
        }
        if (isHTTPS(value)) {
            return 'https://' + stripped;
        }
        return 'http://' + stripped;
    }
    return stripped;
}
export function isHTTP(value) {
    if (!value) {
        return false;
    }
    value = value.toLowerCase();
    return value.startsWith('http://');
}
export function isHTTPS(value) {
    if (!value) {
        return false;
    }
    value = value.toLowerCase();
    return value.startsWith('https://');
}
